import { render, staticRenderFns } from "./Gangway.vue?vue&type=template&id=a2842c42&scoped=true&"
import script from "./Gangway.vue?vue&type=script&lang=js&"
export * from "./Gangway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2842c42",
  null
  
)

export default component.exports